export default "__VITE_ASSET__DFnyJz1k__"